import React from 'react';
import {
	Route,
	RouteNotFound,
	useLocation,
	useHistory
} from 'reaouter';
import { Sidebar } from 'Templates'; 
import { DocumentationFacade } from 'Source/App/Main/Facades';
import { Introduction, Draggerjs, Poppingjs } from './Topics';
import { PageNotFound, ComingSoon } from '../';

export const JavascriptPage = () => {
	const location = useLocation(); 
	const history = useHistory()
	return (
		<>
			<Route path={`${location.path}`} render={<Introduction />} />
			{history.url !== location.url && (
				<>
					<JavascriptPageSide {...location} />
					<JavascriptPageMain {...location} />
				</>
			)}
		</>
	);
};

const JavascriptPageSide = ({ url }) => {
	const links = [  
		{ to: `${url}/croppiejs`, label: 'croppiejs', undev: true },
		{ to: `${url}/draggerjs`, label: 'draggerjs' },
		{ to: `${url}/datepickerjs`, label: 'datepickerjs', undev: true }, 
		{ to: `${url}/magnifyjs`, label: 'magnifyjs', undev: true },
		{ to: `${url}/poppingjs`, label: 'poppingjs' },
		{ to: `${url}/selectjs`, label: 'selectjs', undev: true },
	];
	return <Sidebar links={links} />;
};

const JavascriptPageMain = ({ path, url }) => {
	return (
		<DocumentationFacade>
			<Route path={`${path}/croppiejs`} render={<ComingSoon/>}/>
			<Route path={`${path}/draggerjs`} render={<Draggerjs/>}/> 
			<Route path={`${path}/datepickerjs`} render={<ComingSoon/>}/>
			<Route path={`${path}/magnifyjs`} render={<ComingSoon/>}/>
			<Route path={`${path}/poppingjs`} render={<Poppingjs/>}/>
			<Route path={`${path}/selectjs`} render={<ComingSoon/>}/>
			<RouteNotFound render={<PageNotFound />} />
		</DocumentationFacade>
	);
};

export default JavascriptPage
